import { LoadingSpinner } from "@JohnLewisPartnership/jl-design-system/dist/components/loading-spinner/LoadingSpinner";
import { IngredientList } from "./components/IngredientList/IngredientList";
import { EANStatus, LoadData } from "@/hooks/useSkinMatch/skinMatchService";

type Props = {
  ean: string;
  skinMatchLookUpData: LoadData<EANStatus>;
  skinMatchIngredientBaseUrl: string;
  pimProductId: string;
  variantId: string;
  dispatchMonetateImpression: () => void;
};

export const IngredientsUI = ({
  ean,
  skinMatchLookUpData,
  skinMatchIngredientBaseUrl,
  pimProductId,
  variantId,
  dispatchMonetateImpression,
}: Props) => {
  switch (skinMatchLookUpData.status) {
    case "No Action":
    case "Error":
      return null;
    case "Loading":
      return <LoadingSpinner />;
    case "Done": {
      const {
        data: { skinMatchStatus },
      } = skinMatchLookUpData;

      return skinMatchStatus ? (
        <IngredientList
          ean={ean}
          skinMatchIngredientBaseUrl={skinMatchIngredientBaseUrl}
          pimProductId={pimProductId}
          variantId={variantId}
          dispatchMonetateImpression={dispatchMonetateImpression}
        />
      ) : null;
    }
    default: {
      return null;
    }
  }
};
